export const SPEC_COMP_LIST = [
    '宁波美美家园服务有限公司',
    '宁波美美家园电器服务有限公司',
    '宁波美美家园电器公司',
    '宁波美美家园电器有限公司',
    '宁波美美家园电器服务公司',
];

export const NO_OPEN_INFO_COMPANY = [
    38951, // 百度
    41633, // 抖音视界有限公司5
    42870, // 北京巨量引擎网络技术有限公司
];